import { BASE_URL } from '../../constants';

const DEFAULT_REQUEST_TIMEOUT_MS = 30_000;

const parsePositiveInteger = (value, fallback) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const API_CONFIG = {
    BASE_URL,
    REQUEST_TIMEOUT_MS: parsePositiveInteger(
        process.env.REACT_APP_API_REQUEST_TIMEOUT_MS,
        DEFAULT_REQUEST_TIMEOUT_MS,
    ),
    ENDPOINTS: {
        POSTS: {
            FEED: `${BASE_URL}/api/posts/feed`,
            FETCH_USER_POSTS: `${BASE_URL}/api/posts/user/me`,
            FETCH_USER_BY_ID: (userId) => `${BASE_URL}/api/posts/user/${userId}`,
            FETCH_BAND_POSTS: (bandObjectId) => `${BASE_URL}/api/posts/bands/${bandObjectId}`,
            CREATE: `${BASE_URL}/api/posts/create`,
            CREATE_BAND_POST: (bandObjectId) => `${BASE_URL}/api/posts/bands/${bandObjectId}/create`,
            UPDATE: (postId) => `${BASE_URL}/api/posts/update/${postId}`,
            DELETE: (postId) => `${BASE_URL}/api/posts/delete/${postId}`,
            REACTIONS: (postId) => `${BASE_URL}/api/posts/${postId}/reactions`,
            COMMENTS: (postId) => `${BASE_URL}/api/posts/${postId}/comments`,
            DETAILS: (postId) => `${BASE_URL}/api/posts/${postId}`,
        },
        AUTH: {
            LOGIN: `${BASE_URL}/api/auth/login`,
            REGISTER: `${BASE_URL}/api/auth/register`,
            REGISTER_EMAIL_START: `${BASE_URL}/api/auth/register/email/start`,
            REGISTER_EMAIL_VERIFY: `${BASE_URL}/api/auth/register/email/verify`,
            REGISTER_EMAIL_RESEND: `${BASE_URL}/api/auth/register/email/resend`,
            LOGOUT: `${BASE_URL}/api/auth/logout`,
            REFRESH_TOKEN: `${BASE_URL}/api/auth/refresh`,
            CURRENT_USER: `${BASE_URL}/api/auth/me`,
        },
        PROFILE: {
            UPDATE: `${BASE_URL}/api/profile/update`,
        },
        MEDIA: {
            UPLOAD_PROFILE_PICTURE: `${BASE_URL}/api/media/profile-picture`,
            GET_PROFILE_PICTURE: `${BASE_URL}/api/media/profile-picture`,
            GET_PROFILE_PICTURE_URL: `${BASE_URL}/api/media/profile-picture/url`,
            DELETE_PROFILE_PICTURE: `${BASE_URL}/api/media/profile-picture`,
            UPLOAD_PROFILE_COVER: `${BASE_URL}/api/media/profile-cover`,
            GET_PROFILE_COVER: `${BASE_URL}/api/media/profile-cover`,
            GET_PROFILE_COVER_URL: `${BASE_URL}/api/media/profile-cover/url`,
            DELETE_PROFILE_COVER: `${BASE_URL}/api/media/profile-cover`,
        },
        GEOCODING: {
            FORWARD: `${BASE_URL}/api/geocoding/forward`,
            REVERSE: `${BASE_URL}/api/geocoding/reverse`,
            AUTOCOMPLETE: `${BASE_URL}/api/geocoding/autocomplete`,
        },
        BILLING: {
            PLANS: `${BASE_URL}/api/billing/v1/plans`,
            SUBSCRIPTION: `${BASE_URL}/api/billing/v1/subscription`,
            CHECKOUT_SESSIONS: `${BASE_URL}/api/billing/v1/checkout-sessions`,
            PORTAL_SESSIONS: `${BASE_URL}/api/billing/v1/portal-sessions`,
            SUBSCRIPTION_CANCEL: `${BASE_URL}/api/billing/v1/subscription/cancel`,
            SUBSCRIPTION_RESUME: `${BASE_URL}/api/billing/v1/subscription/resume`,
            ADMIN_PLANS: `${BASE_URL}/api/billing/v1/admin/plans`,
            ADMIN_PLAN_VERSION_VALIDATE: (planVersionId) => `${BASE_URL}/api/billing/v1/admin/plan-versions/${planVersionId}/validate`,
            ADMIN_PLAN_VERSION_IMPACT_PREVIEW: (planVersionId) => `${BASE_URL}/api/billing/v1/admin/plan-versions/${planVersionId}/impact-preview`,
            ADMIN_PLATINUM_GRANTS: `${BASE_URL}/api/billing/v1/admin/platinum-grants`,
            ADMIN_PLATINUM_GRANT_REVOKE: (userId) => `${BASE_URL}/api/billing/v1/admin/platinum-grants/${userId}/revoke`,
            ADMIN_RECONCILIATION_RUNS: `${BASE_URL}/api/billing/v1/admin/reconciliation-runs`,
            ADMIN_RECONCILIATION_RUN: (runId) => `${BASE_URL}/api/billing/v1/admin/reconciliation-runs/${runId}`,
        },
        AUTH_BILLING_ACTION_GRANTS: {
            PASSWORD_COMPLETE: `${BASE_URL}/api/auth/billing-action-grants/password/complete`,
        },
    },
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
    },
}; 
